import axios from 'axios'

const cmsApi = axios.create({
  baseURL: process.env.VUE_APP_CMS_API,
  timeout: 15000
})

const javaApi = axios.create({
  baseURL: process.env.VUE_APP_JAVA_API,
  timeout: 10000
})

const parseStrapiData = (response) => {
  if (!response || !response.data) return null
  const raw = response.data.data
  if (raw == null) return null
  if (!Array.isArray(raw)) {
    return { id: raw.id, ...raw.attributes }
  }
  return raw.map((item) => ({
    id: item.id,
    ...item.attributes
  }))
}

/** 拼接 CMS 媒体地址：Strapi 返回 /uploads/...，经域名访问需与 nginx /uploads 配置一致 */
const joinCmsMediaUrl = (url) => {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url
  const base = (process.env.VUE_APP_CMS_URL || '').replace(/\/+$/, '')
  const path = url.startsWith('/') ? url : `/${url}`
  return `${base}${path}`
}

export const getMediaUrl = (media) => {
  if (!media) return ''
  const url = media.url || media.data?.attributes?.url
  return joinCmsMediaUrl(url)
}

/** Strapi 多图字段 gallery.data[] */
export const getGalleryUrls = (gallery) => {
  if (!gallery) return []
  const data = gallery.data
  if (!data) return []
  const list = Array.isArray(data) ? data : [data]
  return list
    .map((item) => joinCmsMediaUrl(item.attributes?.url))
    .filter(Boolean)
}

export default {
  async getSiteBanners() {
    const res = await cmsApi.get('/site-banners', {
      params: {
        populate: 'backgroundImage',
        sort: 'sortOrder:asc',
        'pagination[pageSize]': 10
      }
    })
    return parseStrapiData(res)
  },

  async getSolutions() {
    const res = await cmsApi.get('/solutions', {
      params: {
        populate: 'coverImage',
        sort: 'sortOrder:asc',
        'pagination[pageSize]': 20
      }
    })
    return parseStrapiData(res)
  },

async getSolutionDetail(id) {
    const res = await cmsApi.get(`/solutions/${id}`, {
      params: {
       'populate[0]': 'coverImage',
        'populate[1]': 'gallery',
        'populate[2]': 'category',
        'populate[3]': 'imgs'
      }
    })
    return parseStrapiData(res)
  },

  async getProductCategories() {
    const res = await cmsApi.get('/product-categories', {
      params: {
        sort: 'sortOrder:asc',
        'pagination[pageSize]': 50
      }
    })
    return parseStrapiData(res)
  },

  async getNewsList(page = 1, pageSize = 10) {
    const res = await cmsApi.get('/news', {
      params: {
        populate: 'coverImage',
        sort: 'publishDate:desc',
        'pagination[page]': page,
        'pagination[pageSize]': pageSize,
        'pagination[withCount]': true
      }
    })
    const list = parseStrapiData(res)
    const items = Array.isArray(list) ? list : []
    items.pagination = (res && res.data && res.data.meta && res.data.meta.pagination) || {
      page,
      pageSize,
      pageCount: 0,
      total: items.length
    }
    return items
  },

  async getNewsDetail(id) {
    const res = await cmsApi.get(`/news/${id}`, {
      params: { populate: 'coverImage' }
    })
    return parseStrapiData(res)
  },

  async getProducts() {
    const res = await cmsApi.get('/products', {
      params: {
        'populate[0]': 'coverImage',
        'populate[1]': 'gallery',
        'populate[2]': 'category',
        'pagination[pageSize]': 100
      }
    })
    return parseStrapiData(res)
  },

  async getProductDetail(id) {
    const res = await cmsApi.get(`/products/${id}`, {
      params: {
        'populate[0]': 'coverImage',
        'populate[1]': 'gallery',
        'populate[2]': 'category'
      }
    })
    return parseStrapiData(res)
  },

  async getCompanyInfo() {
    const res = await cmsApi.get('/company-info', {
      params: {
        'populate[0]': 'logo',
        'populate[1]': 'qrWechat',
        'populate[2]': 'qrApp',
        'populate[3]': 'homeAboutGallery'
      }
    })
    return parseStrapiData(res)
  },

  async getDownloads() {
    const res = await cmsApi.get('/downloads', {
      params: {
        populate: 'file',
        'sort[0]': 'sort:asc',
        'sort[1]': 'updateTime:desc',
        'pagination[pageSize]': 100
      }
    })
    return parseStrapiData(res)
  },

  async createDownloadRegister(payload) {
    const data = {
      name: payload.name,
      organization: payload.organization,
      phone: payload.phone,
      email: payload.email,
      remark: payload.remark,
      resourceId: payload.resourceId,
      resourceTitle: payload.resourceTitle || payload.title
    }
    const res = await cmsApi.post('/download-registers', { data })
    return parseStrapiData(res)
  },

  async submitMessage(data) {
    const res = await javaApi.post('/messages', data)
    return res.data
  },

  async submitAppointment(data) {
    const res = await javaApi.post('/appointments', data)
    return res.data
  }
}
